module.exports = __webpack_public_path__ + "static/media/btn-updatecalendar.b4365e58.svg";